module.exports = __webpack_public_path__ + "img/gallery-7.674d9703.webp";